import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import feedType from '../../../../context/FeedContext/config/feedTypes';
import CheckInStats from '../../../../components/CheckInStats';
import ClientWeightChartModal from '../../../../components/ClientWeightChart';
import { CHAT_SILENCE_INDICATOR_LABEL } from '../../../../constants/disengagementFilters';
import CoachTaskContent from '../CoachTaskContent';
import { toJsDate } from '../../../../../utils/date';

import { ActivityContentContainer, CriteriaChipsContainer, CriteriaChip } from './styles';

const ActivityContent = ({ activity, clientUserDoc }) => {
  const [showWeightHistoryModal, setShowWeightHistoryModal] = useState(false);

  /*
    A product-scoped card carries its own product's date; the client-level value on the user
    doc is a maximum across every product and would style this card from a sibling's date.
    Cards predating that stamp have no productId and keep reading the user doc. Feed
    activities expose raw Firestore Timestamps, so both sources go through toJsDate.
  */
  const lastAssignedDate = toJsDate(activity.productId
    ? activity.lastWorkoutAssignedDate
    : clientUserDoc?.lastWorkoutAssignedDate);

  const isLastAssignedDateInPast = activity.type === feedType.NEED_NEW_WORKOUTS
  && lastAssignedDate
  && moment.utc(lastAssignedDate).isBefore(moment.utc(), 'day');

  if (activity.type === feedType.DISENGAGED_CLIENT) {
    if (!activity.chatSilent) {
      return null;
    }
    return (
      <CriteriaChipsContainer>
        <CriteriaChip
          label={CHAT_SILENCE_INDICATOR_LABEL}
          color="warning"
          size="small"
          variant="outlined"
        />
      </CriteriaChipsContainer>
    );
  }

  if (activity.type === feedType.COACH_TASK) {
    return <CoachTaskContent activity={activity} />;
  }

  if (activity.type === feedType.CHECK_IN) {
    return (
      <>
        <CheckInStats
          isNotification
          activity={activity}
          title={activity.content}
          onWeightHistoryClick={() => setShowWeightHistoryModal(true)}
          clientUserDoc={clientUserDoc}
        />
        {showWeightHistoryModal && (
          <ClientWeightChartModal
            showModal={showWeightHistoryModal}
            onClose={() => setShowWeightHistoryModal(false)}
            clientId={activity.user}
            coachId={activity.coach}
          />
        )}
      </>
    );
  }
  return (
    <ActivityContentContainer
      isLastAssignedDateInPast={isLastAssignedDateInPast}
    >
      {activity.content}
    </ActivityContentContainer>
  );
};

ActivityContent.propTypes = {
  activity: PropTypes.object,
  clientUserDoc: PropTypes.object,
};

ActivityContent.defaultProps = {
  activity: {},
  clientUserDoc: null,
};

export default ActivityContent;
